module.exports = __webpack_public_path__ + "img/slider7.5d89f989.png";